// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__mO-gO","footer_container_data":"Footer_footer_container_data__rKd1T","legal":"Footer_legal__gudLg","dec":"Footer_dec__vGjhE"};